import { Component } from '@angular/core';

@Component({
  selector: 'edge-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class PageHomeComponent {
  tagline = '<span>GoArmy Edge.</span> Create. Visualize. Learn. Compete.';
  testimonial = `
    "As a defensive coordinator, alignment along with fits are the primary focus
    for every game planning staff meeting. We work through our game as a staff
    and have the GoArmy Edge program on the wall with film to test our ideas and
    fits. It really gives you another dimension beyond static X's & O's on the
    board. We are able to find good ideas and also notice some issues seeing
    things animated on the app. Huge deal for visual people, as most of us coaches are."`;
  author = 'Coach Rob Everett';
}
